import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './@/components/ui/dialog';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './@/components/ui/accordion';
import { displayRole } from './roleLabel';
import './ShiftDetails.css';

const ShiftDetails = ({ shift, onClose, schedule_assignment_reasons, partnerId }) => {
  const formatPoints = (points) => {
    return parseFloat(points).toFixed(2);
  };

  const renderSubRules = (subRules) => {
    return subRules.map(([subRuleName, passed, points, details], index) => (
      <div key={index} className="sub-rule">
        <span className="sub-rule-name">{subRuleName}: </span>
        <span className={`sub-rule-status ${passed ? 'passed' : 'failed'}`}>
          {passed ? 'Passed' : 'Failed'}
        </span>
        <span className={`sub-rule-points ${points >= 0 ? 'points-positive' : 'points-negative'}`}>
          ({formatPoints(points)} points)
        </span>
        {details && <p className="sub-rule-details">{details}</p>}
      </div>
    ));
  };

  const renderEmployeeDetails = (employee, employeeName) => {
    if (!employee || !employee.rules) return null;

    const totalPoints = employee.total_points;
    console.log(employeeName, totalPoints);
    const pointsClass = totalPoints >= 0 ? 'points-positive' : 'points-negative';

    return (
      <Accordion type="single" collapsible className="employee-accordion">
        <AccordionItem value={employeeName}>
          <AccordionTrigger className="employee-accordion-header">
            {employeeName}: <span className={pointsClass}>{formatPoints(totalPoints)}</span>
          </AccordionTrigger>
          <AccordionContent className="employee-accordion-content">
            {Object.entries(employee.rules).map(([ruleName, ruleData], index) => (
              <Accordion type="single" collapsible key={index} className="rule-accordion">
                <AccordionItem value={ruleName}>
                  <AccordionTrigger className="rule-accordion-header">
                    {ruleName}: <span className={ruleData.passed ? 'points-positive' : 'points-negative'}>
                      {formatPoints(ruleData.total_points)}
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="rule-accordion-content">
                    {renderSubRules(ruleData.sub_rules)}
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            ))}
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    );
  };

  const formatTime = (time) => {
    const hours = Math.floor(time);
    const minutes = Math.round((time - hours) * 60);
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  };

  const shiftKey = shift.shift_id;
  console.log(shiftKey);
  const shiftDetails = schedule_assignment_reasons[shiftKey];
  console.log(shiftDetails);

  return (
    <Dialog open={!!shift} onOpenChange={onClose} className="shift-details-dialog">
      <DialogContent className="shift-details-content">
        <DialogHeader className="shift-details-header">
          <DialogTitle className="shift-details-title">
            {shift.name} ({displayRole(shift.role, partnerId)}) - {formatTime(shift.start)} to {formatTime(shift.end)}, {shift.day}
          </DialogTitle>
          <DialogDescription className="shift-details-description">
            Details for the selected shift
          </DialogDescription>
        </DialogHeader>
        <div className="shift-details-body">
          {shift.setShiftOutcome && (
            <div className="shift-details-section shift-details-set-shift">
              <strong>Set shift:</strong> {shift.setShiftOutcome.constraint_type}
            </div>
          )}
          {shiftDetails ? (
            <>
              {shiftDetails.selected && (
                <div className="shift-details-section">
                  <h3 className="shift-details-section-title">Selected employee:</h3>
                  {renderEmployeeDetails(Object.values(shiftDetails.selected)[0], Object.keys(shiftDetails.selected)[0])}
                </div>
              )}
              <div className="shift-details-section">
                <h3 className="shift-details-section-title">Not selected employees:</h3>
                <div>
                  {Object.entries(shiftDetails.not_selected)
                    .sort(([, a], [, b]) => b.total_points - a.total_points)
                    .map(([employeeName, employeeData]) => 
                      renderEmployeeDetails(employeeData, employeeName)
                    )}
                </div>
              </div>
            </>
          ) : (
            <p>No details available for this shift.</p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ShiftDetails;